import { buildChannelPayload, CHANNEL_TRACKING_URL } from '../helpers/channelTracking';
import apiClient from '../middleware/apiClient';
import { flagEnabled } from '../helpers/featureFlags';
import { COTTON_CHANNEL_TRACKING_URL } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const SEND_CHANNEL_TRACKING = 'SEND_CHANNEL_TRACKING';

/**
 * @import {ChannelTrackingId} from '../helpers/channelTracking';
 *
 * @typedef {Object} SendChannelTrackingOptions
 * @property {ChannelTrackingId} id Channel tracking action ID
 * @property {Error} [error] Error object if this action is an error
 * @property {string} [interactionType] Interaction type for the channel tracking payload
 * @property {Object} [metadata] Additional metadata to include in the channel tracking payload
 *
 * @typedef {Object} SendChannelTrackingReturn
 * @property {typeof SEND_CHANNEL_TRACKING} id
 * @property {Promise<any>} [payload]
 *
 * @param {SendChannelTrackingOptions} options
 * @returns {SendChannelTrackingReturn}
 */
export const sendChannelTracking = ({
  id,
  error,
  interactionType,
  metadata,
  contextHubMigratedSource = false,
}) => async (dispatch, getState) => {
  if (!flagEnabled('global.channelTracking')) {
    return {
      id: SEND_CHANNEL_TRACKING,
      payload: Promise.resolve(),
    };
  }
  const {
    harness: { isHarness },
    auth: { macaroon = {} },
    user: { user: { authGuid } = {} } = {},
    account: { account: legacyAccount },
    contextHub: { contextHub: contextHubAccount = {} } = {},
  } = getState();
  const isCottonSession = getCottonSession();
  return {
    id: SEND_CHANNEL_TRACKING,
    payload: apiClient.fetch(isCottonSession ? COTTON_CHANNEL_TRACKING_URL : CHANNEL_TRACKING_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildChannelPayload({
        id,
        error,
        macaroon,
        legacyAccount,
        contextHubAccount,
        authGuid,
        contextHubMigratedSource,
        isHarness,
        interactionType,
        metadata,
      })),
    }),
  };
};
